export default __webpack_public_path__ + "static/media/DailyBruinLogo.6ac33239.svg";